import React, { useEffect, useState } from 'react';
import { Search, Shield } from 'lucide-react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import './Admin.css';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/admin/users?search=${search}&limit=50`);
      setUsers(res.data.users);
    } catch { toast.error('Failed to load users'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchUsers(); }, [search]);

  const toggleRole = async (userId, currentRole) => {
    const newRole = currentRole === 'admin' ? 'user' : 'admin';
    if (!window.confirm(`Change user role to ${newRole}?`)) return;
    try {
      const res = await api.put(`/admin/users/${userId}/role`, { role: newRole });
      setUsers(prev => prev.map(u => u._id === userId ? res.data.user : u));
      toast.success('Role updated!');
    } catch { toast.error('Update failed'); }
  };

  return (
    <div className="admin-page">
      <div className="admin-header"><h1>Users</h1></div>
      <div className="admin-card">
        <div className="admin-toolbar">
          <div className="admin-search"><Search size={16} /><input placeholder="Search users..." value={search} onChange={e => setSearch(e.target.value)} /></div>
        </div>
        {loading ? <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" /></div> : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead><tr><th>User</th><th>Email</th><th>Joined</th><th>Role</th><th>Toggle Role</th></tr></thead>
              <tbody>
                {users.map(user => (
                  <tr key={user._id}>
                    <td><strong>{user.name}</strong></td>
                    <td style={{ color: 'var(--gray-600)' }}>{user.email}</td>
                    <td style={{ fontSize: 13, color: 'var(--gray-500)' }}>{new Date(user.createdAt).toLocaleDateString()}</td>
                    <td>
                      <span style={{ background: user.role === 'admin' ? 'rgba(201,168,76,0.15)' : 'var(--gray-100)', color: user.role === 'admin' ? 'var(--gold-dark)' : 'var(--gray-600)', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        {user.role === 'admin' && <Shield size={11} />} {user.role}
                      </span>
                    </td>
                    <td>
                      <button className="btn-secondary" style={{ padding: '6px 12px', fontSize: 12 }} onClick={() => toggleRole(user._id, user.role)}>
                        {user.role === 'admin' ? 'Remove Admin' : 'Make Admin'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
